import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import { StyledPropertyCardPhotoHeader } from './PropertyCardPhotoHeader.styles';

/**
 * A container that appears at the top of a property photo in a `PropertyCard`.
 * Usually contains a `PropertyCard.Badge`.
 *
 * @since 8.63.0
 */
export var PropertyCardPhotoHeader = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(StyledPropertyCardPhotoHeader, _extends({
    ref: forwardedRef
  }, props));
});
PropertyCardPhotoHeader.displayName = 'PropertyCard.PhotoHeader';